import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

const CloseAgeverifButton = ({ history, dispatch, location }) => {
    const [isVisible, setIsVisible] = useState(false);



    useEffect(() => {
        const checkElement = () => {
            const el = document.querySelector('#ageverif-checker');
            if (el) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
        };

        checkElement();

        const interval = setInterval(checkElement, 500);

        return () => clearInterval(interval);
    }, []);

    const handleClick = () => {
        const ageVerifElement = document.querySelector('#ageverif-checker');
        if (ageVerifElement && window.ageverif && typeof window.ageverif.destroy === 'function') {
            window.ageverif.destroy();
            history.push(location.pathname);
            setIsVisible(false);
        }
    };

    if (!isVisible) return null;

    return (
        <div
            onClick={handleClick}
            className="icon-menu active"
            style={{cursor: 'pointer', zIndex: 99999, position: 'fixed', top: 10, right: 10}}
        >
            <svg width="22" height="22" viewBox="0 0 22 22">
                <path d="M583.992 247.854L600.963 230.88400000000001L603.51 233.43L586.538 250.4Z "
                      transform="matrix(1,0,0,1,-583,-230)"></path>
                <path d="M604.005 247.854L587.034 230.88400000000001L584.489 233.43L601.4590000000001 250.4Z "
                      transform="matrix(1,0,0,1,-583,-230)"></path>
            </svg>
        </div>
    );
};

export default connect()(withRouter(CloseAgeverifButton));



// WEBPACK FOOTER //
// ./src/components/closaAgeVerifButton/closeAgeverifButton.js